/* modal設定*/

function onModalOpen(e) {
    e.preventDefault();
    var target = $(this).data('target');
    var modal = document.getElementById(target);
    scrollPosition = $(window).scrollTop();
    $('body').addClass('fixed').css({ top: -scrollPosition });
    $(modal).fadeIn();
    return false;
}

function onModalWin(e) {
    e.preventDefault();
    var target = $(this).data('target');
    var modal = document.getElementById(target);
    scrollPosition = $(window).scrollTop();
    $('body').addClass('fixed').css({ top: -scrollPosition });
    $(modal).fadeIn();
    return false;
}

function onModalClose(e) {
    e.preventDefault();
    $('body').removeClass('fixed');
    window.scrollTo(0, scrollPosition);
    $('.js-modal').fadeOut();
    return false;
}

// イベントを重複登録しないために、イベント削除を行う
$('.bt_modal_open').off('click');
$('.modal_win').off('click');
$('.bt_modal_close').off('click');

// イベントの登録
$('.bt_modal_open').on('click', onModalOpen);
$('.modal_win').on('click', onModalWin);
$('.bt_modal_close').on('click', onModalClose);

// $('.bt_modal_open').on('click', function (e) {
//     var target = $(this).data('target');
//     var modal = document.getElementById(target);
//     scrollPosition = $(window).scrollTop();
//     $('body').addClass('fixed').css({ top: -scrollPosition });
//     $(modal).fadeIn();
//     return false;
// });

// $('.modal_win').on('click', function (e) {
//     var target = $(this).data('target');
//     var modal = document.getElementById(target);
//     scrollPosition = $(window).scrollTop();
//     $('body').addClass('fixed').css({ top: -scrollPosition });
//     $(modal).fadeIn();
//     return false;
// });

// $('.bt_modal_close').on('click', function (e) {
//     $('body').removeClass('fixed');
//     window.scrollTo(0, scrollPosition);
//     $('.js-modal').fadeOut();
//     return false;
// });
